module.exports = __webpack_public_path__ + "static/media/extraterrestrial-alien_1f47d.5d6dd1d6.png";